import React, { useRef, useEffect } from "react";
import { Chart } from "chart.js/auto";
import { barChartOptions } from "../config/chartOptions";

const WorkedHoursChart = ({
    data,
    title,
    hideHeader = false,
    height = "300px",
}) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (!data || !chartRef.current) return;
        if (chartInstance.current) chartInstance.current.destroy();

        const ctx = chartRef.current.getContext("2d");

        chartInstance.current = new Chart(ctx, {
            type: "bar",
            data,
            options: {
                ...barChartOptions,
                plugins: {
                    ...barChartOptions.plugins,
                    title: {
                        display: !hideHeader,
                        text: title || "Отработанные часы",
                        font: {
                            size: 16,
                            weight: "normal",
                        },
                        color: "#E5E7EB",
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                const minutes = context.parsed.y * 60;
                                const hrs = Math.floor(minutes / 60);
                                const mins = Math.round(minutes % 60);
                                return `${context.dataset.label}: ${hrs}ч ${mins
                                    .toString()
                                    .padStart(2, "0")}м`;
                            },
                        },
                    },
                },
                scales: {
                    ...barChartOptions.scales,
                    x: { ...barChartOptions.scales.x, stacked: true },
                    y: { ...barChartOptions.scales.y, stacked: true },
                },
            },
        });

        return () => {
            if (chartInstance.current) chartInstance.current.destroy();
        };
    }, [data]);

    if (!data) {
        return (
            <div className="flex justify-center items-center h-64 bg-[#2D2D30] rounded-lg border border-[#3E3E42]">
                <p className="text-gray-400">Нет данных для отображения</p>
            </div>
        );
    }

    return (
        <div style={{ height }}>
            <canvas ref={chartRef}></canvas>
        </div>
    );
};

export default WorkedHoursChart;
